const FrequencyType = Object.freeze({
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  BI_ANNUALLY: "Bi-annually",
  YEARLY: "Yearly",
});

export default FrequencyType;
